/**
 * Utility function for pathname checking
 */

/**
 * Checks if the current pathname includes the given string
 * @param {string} pathname - The pathname to check (e.g., "createNoCustomerInvoice")
 * @returns {boolean} True if current pathname includes the given pathname
 */
export const isPathname = (pathname) => {
  return window.location.pathname.includes(pathname);
};
